import { FormProps } from "@/components/form";
import { Form } from "@/components/form";
import { z } from "zod/v4";

export const actividadComercialFormSchema = z.object({
  codigo: z.string().nonempty("Este campo es requerido"),
  nombre: z.string().nonempty("Este campo es requerido"),
})

export default function ActividadComercialForm({
  form,
  ...props
}: FormProps<z.infer<typeof actividadComercialFormSchema>>) {
  return <Form form={form} gap={3} {...props}>
    <Form.TextField name="codigo" label="Código" />
    <Form.TextField name="nombre" label="Nombre" />
    <Form.SubmitButton>Guardar</Form.SubmitButton>
  </Form>
}
